import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function IoTMenu() {
    const MenuCard = ({link, title, icon, color}) => (
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-4">

            <Link
                to={link}
                className="menu-link"
            >

                <div
                    className="menu-card"
                    style={{
                        borderTop: `4px solid ${color}`
                    }}
                >

                    <div
                        className="menu-icon"
                        style={{
                            color: color
                        }}
                    >

                        <FontAwesomeIcon
                            icon={icon}
                            size="2x"
                        />

                    </div>

                    <p className="menu-title">
                        {title}
                    </p>

                </div>

            </Link>

        </div>
    );
    return (
        <section className="container-fluid mt-4">

            {/* ==================================================
                IoT MONITORING
            ================================================== */}

            <h5 className="menu-section-title">
                IoT Monitoring
            </h5>

            <div className="row">

                <MenuCard
                    link="/iot-live-monitoring"
                    title="Live Monitoring"
                    icon="fa-solid fa-heart-pulse"
                    color="#dc3545"
                />

                <MenuCard
                    link="/iot-alarms"
                    title="IoT Alarms"
                    icon="fa-solid fa-triangle-exclamation"
                    color="#fd7e14"
                />

            </div>


            {/* ==================================================
                IoT DEVICES
            ================================================== */}

            <h5 className="menu-section-title">
                IoT Devices
            </h5>

            <div className="row">

                <MenuCard
                    link="/iot-devices"
                    title="IoT Devices"
                    icon="fa-solid fa-microchip"
                    color="#0d6efd"
                />

                <MenuCard
                    link="/iot-device-form"
                    title="Add IoT Device"
                    icon="fa-solid fa-plus"
                    color="#20c997"
                />

                <MenuCard
                    link="/iot-device-mapping"
                    title="Device → Patient Mapping"
                    icon="fa-solid fa-link"
                    color="#6f42c1"
                />

            </div>


            {/* ==================================================
                IoT GATEWAYS
            ================================================== */}

            <h5 className="menu-section-title">
                IoT Gateways
            </h5>

            <div className="row">

                <MenuCard
                    link="/iot-gateways"
                    title="IoT Gateways"
                    icon="fa-solid fa-network-wired"
                    color="#6610f2"
                />

                <MenuCard
                    link="/iot-gateway-form"
                    title="Add IoT Gateway"
                    icon="fa-solid fa-server"
                    color="#0dcaf0"
                />

            </div>


            {/* ==================================================
                PATIENT IoT
            ================================================== */}

            <h5 className="menu-section-title">
                Patient IoT
            </h5>

            <div className="row">

                <MenuCard
                    link="/iot-live-monitoring"
                    title="Patient Live Vitals"
                    icon="fa-solid fa-bed-pulse"
                    color="#198754"
                />

            </div>

        </section>
    );
}
export default IoTMenu;